/*
 * File: SuggestedQuestionsWidget.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:57 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { ClampContent } from '../ClampContent';
import { Card } from '../Card';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: -10px;

	a:first-child {
		margin-top: 10px;
	}
`;

export const SuggestedQuestion = styled(Card)`
	display: inline-flex;
	align-items: start;
	padding: 5px 10px;
	gap: 8px;
	border-radius: 6px;

	svg {
		margin-top: 4px;
	}
`;

export const GrowClampContent = styled(ClampContent)`
	flex-grow: 1;
`;
